// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.flex-row[data-v-75f644c6] {\n  display: flex;\n  flex-wrap: wrap;\n}\n.flex-basis-40[data-v-75f644c6] {\n  flex-basis: 40%;\n}\n.flex-basis-50[data-v-75f644c6] {\n  flex-basis: 50%;\n}\n.flex-basis-18[data-v-75f644c6] {\n  flex-basis: 18%;\n  padding: 1.3rem 0;\n}\n.align-center[data-v-75f644c6] {\n  text-align: center;\n}\n.country-desc[data-v-75f644c6] {\n  min-width: 16.5rem;\n}\n", ""]);
// Exports
module.exports = exports;
